module.exports = __webpack_public_path__ + "static/ic_win_noPrize@2x.dd7fa1b6.png";